const l = {
  name: "Dept",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24.3,10.7L21,7.4v25.2l7.3-7.3l1.4,1.4L20,36.4l-9.7-9.7l1.4-1.4l7.3,7.3V7.4l-3.3,3.3l-1.4-1.4L20,3.6
			l5.7,5.7L24.3,10.7z"/>
		<path class="st0" d="M30.8,0H9.2L0,40h40L30.8,0z M2.5,38l8.3-36h18.4l8.3,36H2.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Dept
};
